import { Vector2 } from "three";
import * as PIXI from "pixi.js";
import * as Three from "three";
import {CanvasType} from "./canvas.service";

export namespace CanvasState {
  export const renderers: Map<string, PIXI.Renderer> = new Map();
  export const canvass: Map<CanvasType, HTMLCanvasElement> = new Map();
  export const canvasDimensions: Map<CanvasType, Vector2> = new Map();
  export const canvasTextures: Map<CanvasType, Three.CanvasTexture> = new Map();
  export const canvasStages: Map<CanvasType, PIXI.Container> = new Map();
}
